export function isContentEditor(): Ref<boolean> {
  const user = useSupabaseUser();

  return computed(() => user.value?.app_metadata?.content_administrator || false);
}